import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SmsModule } from '../sms/sms.module';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'trai-reports' },
  {
    path: 'login',
    loadChildren: () =>
      import('../authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      ),
  },
  {
    path: 'trai-reports',
    loadChildren: () =>
      import('../report-trai/report-trai.module').then(
        (m) => m.ReportTraiModule
      ),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('../profile/profile.module').then((m) => m.ProfileModule),
  },
  // { path: 'dashboard', loadChildren: () => import('../dashboard/dashboard.module').then(m => m.DashboardModule) },
  {
    path: 'logs',
    loadChildren: () => import('../logs/logs.module').then((m) => m.LogsModule),
  },
  {
    path: 'change-password',
    loadChildren: () =>
      import('../change-password/change-password.module').then(
        (m) => m.ChangePasswordModule
      ),
  },
  {
    path: 'licence-logs',
    loadChildren: () =>
      import('../channels/channels.module').then((m) => m.ChannelsModule),
  },
   {
    path: 'command-logs',
    loadChildren: () =>
      import('../command-logs/command-logs.module').then((m) => m.CommandLogsModule),
  },

  {
    path: 'stb',
    loadChildren: () => import('../stb/stb.module').then((m) => m.StbModule),
  },
  { path: 'sms', loadChildren: () => SmsModule },
  {
    path: 'crypto-period',
    loadChildren: () =>
      import('../crypto-period/crypto-period.module').then(
        (m) => m.CryptoPeriodModule
      ),
  },
  {
    path: '**',
    loadChildren: () =>
      import('../not-found/not-found.module').then((m) => m.NotFoundModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CoreRoutingModule {}
